import { ChangeDetectorRef, Component, OnDestroy, } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Event, NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TourService } from 'ngx-ui-tour-ngx-bootstrap';
import { CommonService } from 'projects/crm-services/src/lib/proxy/crmservice/common-service';
import { filter, Subscription } from 'rxjs';
import { TourShareService } from './tour-share-service';

@Component({
  selector: 'app-common-tour',
  templateUrl: './common-tour.component.html',
  styleUrl: './common-tour.component.scss'
})
export class CommonTourComponent implements OnDestroy {
  private steps = [];
  globalAnchorIds: string[] = [];
  anchorValues: string[];
  private observer: MutationObserver;
  private debounceTimeout: any;
  private processedAnchors: Set<string> = new Set();
  private routePath: any;
  tourSteps: any;
  private clearCookieSubscription: Subscription;
  constructor(
    private readonly tourService: TourService,
    private readonly sanitizer: DomSanitizer,
    private readonly commonService: CommonService,
    private readonly cdRef: ChangeDetectorRef, private readonly router: Router, private readonly cookieService: CookieService,
    private readonly tourShareService: TourShareService

  ) {
    this.tourService.end$.subscribe(() => {
      this.onTourEnd();
    });
    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.urlGet(event.urlAfterRedirects);
      if (this.routePath != undefined) {
        this.fetchPageMasterAndTour();
      }
    });
    if (this.routePath == undefined) {
      this.initializeRoutePath();
    }
  }
  ngOnInit(): void {
    this.clearCookieSubscription = this.tourShareService.clearCookie$.subscribe(() => {
      this.topbarTour();
    });
  }
  urlGet(urls: any) {
    const fullPath = urls.split('?')[0];
    const segments = fullPath.replace(/\/$/, '').split('/');
    const lastSegment = segments.pop();
    if (lastSegment && !isNaN(Number(lastSegment))) {
      this.routePath = segments.pop();
    } else {
      this.routePath = lastSegment;
    }
  }
  initializeRoutePath() {
    this.urlGet(this.router.url);
    this.processedAnchors = new Set();
    if (this.routePath) {
      this.fetchPageMasterAndTour();
    }
  }

  fetchPageMasterAndTour() {
    if (this.routePath && this.routePath != null) {
      this.commonService.getPageMasterAndTourByRouterNameAndProjectType(this.routePath, 3).subscribe(
        (result: any) => {
          this.processedAnchors = new Set();
          this.tourSteps = result.pageTourDTO;
          this.cdRef.detectChanges();
        },
      );
    }
  }

  ngAfterViewInit() {
    const startObserving = () => {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    this.observer = new MutationObserver(() => {
      this.debounceCheckForNewAnchors();
      this.observer.disconnect();

      setTimeout(() => {
        startObserving();
      }, 500);
    });

    startObserving();
  }

  debounceCheckForNewAnchors() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.checkForNewAnchors();
    }, 300);
  }


  checkForNewAnchors() {
    const newAnchorElements = document.querySelectorAll('[tourAnchor]');
    const visitedAnchors = JSON.parse(this.cookieService.get('visitedAnchors') || '[]');
    this.anchorValues = [];
    newAnchorElements.forEach((element: Element) => {
      const anchorValue = element.getAttribute('tourAnchor');
      const alreadyVisited = visitedAnchors.some(va => va.route === this.routePath && va.anchor.includes(anchorValue));
      if (anchorValue && !this.processedAnchors.has(anchorValue) && !alreadyVisited) {
        this.processedAnchors.add(anchorValue);
        this.anchorValues.push(anchorValue);
      }
    });
    if (this.anchorValues.length > 0) {
      this.Tourinitialize();
    }
  }

  Tourinitialize() {
    if (this.tourSteps) {
      const validSteps = this.tourSteps.filter(step => this.anchorValues.includes(step.buttonId));
      if (validSteps.length > 0) {
        let datas = [];

        validSteps.forEach(element => {
          this.globalAnchorIds.push(element.buttonId);

          let content = `${element.description}`;

          const mp4Regex = /(https?:\/\/[^\s"]+\.mp4)/g;
          const youtubeRegex =
            /https?:\/\/(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)(?:[^\s]*)|https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(?:[^\s]*)/g;

          const videoMatches = Array.from(element.description.matchAll(mp4Regex));
          const youtubeMatches = Array.from(element.description.matchAll(youtubeRegex));

          let addedVideos = [];

          if (videoMatches.length > 0) {
            videoMatches.forEach((match) => {
              const videoUrl = match[0];

              if (!addedVideos.includes(videoUrl)) {
                content = content.replace(videoUrl, `<div class="tour-video-wrapper">
                <video class="tour-video" controls autoplay muted width="100%">
                  <source src="${videoUrl}" type='video/mp4'>
                  Your browser does not support the video tag.
                </video>
              </div>`);
                addedVideos.push(videoUrl);
              }
            });
          }

          if (youtubeMatches.length > 0) {
            youtubeMatches.forEach((match) => {
              const videoId = match[1] ?? match[2];
              const youtubeUrl = `https://www.youtube.com/embed/${videoId}`;

              if (!addedVideos.includes(youtubeUrl)) {
                content = content.replace(match[0], `<div class="tour-video-wrapper">
                <iframe class="tour-iframe"
                  src="${youtubeUrl}"
                  frameborder="0"
                  width="100%"
                  allowfullscreen>
                </iframe>
              </div>`);
                addedVideos.push(youtubeUrl);
              }
            });
          }
          content = content.replace(/(<\/div>).*$/g, '$1');

          const sanitizedContent = this.sanitizeHTML(content);

          const data = {
            anchorId: element.buttonId,
            content: sanitizedContent,
            title: element.title,
          };

          datas.push(data);
        });

        this.steps = datas;

        this.tourService.initialize(this.steps, {
          enableBackdrop: true,
          backdropConfig: { offset: 10 },
        });

        this.startTour();
      }
    }
  }

  onTourEnd() {
    const visitedAnchors = JSON.parse(this.cookieService.get('visitedAnchors') || '[]');
    const existingRouteIndex = visitedAnchors.findIndex(item => item.route === this.routePath);

    if (existingRouteIndex !== -1) {
      this.globalAnchorIds.forEach(anchor => {
        if (!visitedAnchors[existingRouteIndex].anchor.includes(anchor)) {
          visitedAnchors[existingRouteIndex].anchor.push(anchor);
        }
      });
    } else {
      visitedAnchors.push({ route: this.routePath, anchor: (this.globalAnchorIds) });
    }
    this.cookieService.set('visitedAnchors', JSON.stringify(visitedAnchors), 30, '/');
    this.globalAnchorIds = [];

  }

  startTour() {
    this.tourService.start();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  sanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  topbarTour() {
    this.processedAnchors = new Set();
    const visitedAnchors = JSON.parse(this.cookieService.get('visitedAnchors') || '[]');
    const existingRouteIndex = visitedAnchors.findIndex(item => item.route === this.routePath);
    if (existingRouteIndex !== -1) {
      visitedAnchors.splice(existingRouteIndex, 1);
    }
    this.cookieService.set('visitedAnchors', JSON.stringify(visitedAnchors), 30, '/');
    this.debounceCheckForNewAnchors();
  }
}